import { Grid, Typography } from "@mui/material";
import Lista_Blogs from "./SubComponentes/Lista_Blogs";

const Problemas_Home = () => {

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{}}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3 }}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 12 }}
                    sx={{  pb: 0 }}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{ xs: 12, sm: 12, md: 12 }}
                    >
                        <Typography
                            component="h2"
                            variant="h2"
                            sx={{
                                textAlign: 'center',
                            }}
                            itemProp="name"
                        >
                            Problemas que resolvemos en mantenimiento locativo
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ pt: 8 }}>
                        <Lista_Blogs ids={["7", "8", "9"]}  />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Problemas_Home;